import React, { useEffect, useMemo, useState } from 'react';
import { buildPentaNarratives, defaultNarrative } from '../components/Edu/narratives';
import uncertain_narrative_pages from '../components/Edu/uncertain_narrative_pages.json';
import uncertain_narratives from '../components/Edu/uncertain_narratives.json';
import {
  _updateMe,
  drawProfile,
  drawType
} from '../components/utilsDesign';
import { getLocal, setLocal } from '../components/utilsSocial';
import profiles_local from '../static/profiles_local.json';
import types_local from '../static/types_local.json';
import ui_local from '../static/ui_local.json';
import jyotish_ui from '../static/jyotish_ui.json';
import penta_narrative_pages from '../components/Penta/penta_narrative_pages.json';
import penta_narratives from '../components/Penta/penta_narratives.json';

const LangContext = React.createContext();
const UNCERTAIN_NARRATIVES = buildPentaNarratives(uncertain_narratives, uncertain_narrative_pages);

function LangProvider({ children }) {

  const APP_AIRTABLE_CACHE = process.env.REACT_APP_AIRTABLE_CACHE;


  const [changes, setChanges] = useState('');

  const [language, setLanguage1] = useState(getLocal('language') ? getLocal('language') : 'en')
  const [amPm, setAmPm] = useState(getLocal('ampm') ? getLocal('ampm') : 'ampm')

  const setLanguage = (l) => {
    setLanguage1(l);
    setLocal('language', l)
    setAmPm(l === 'en' ? 'ampm' : '24')
    _updateMe({ locale: l })
  }
  const processCrosses = (crosses) => {

    const a = [...Object.values(crosses)]
    // .reduce((acc, record) => {
    //   const id = `${record.angle}_${record.id}`;
    //   acc[id] = record;
    //   return acc;
    // }, {});
    const crossesNew = {}
    a.forEach(record => {
      // const id = `${record.angle}_${record.id}`;
      const id = `${record.id}`;
      crossesNew[id] = {
        ...record,
        id
      }
    })
    return crossesNew
  }

  const processVideos = (videos) => {
    const a = [...Object.values(videos)]
      .filter(record => typeof record === 'object')
      .filter(record => record.active)
    return a
  };



  const processNarratives = (narratives, narrativePages) => {

    if (Object.keys(narratives).length && Object.keys(narrativePages).length) {
      Object.keys(narratives).forEach(oneNarrativeId => {
        const oneNarrative = narratives[oneNarrativeId];

        const getPage = (pageId) => {
          const narrativePagesIdsArray = Object.values(narrativePages).filter(one => typeof narrativePages.one !== 'object');
          const narrativePagesNew = {}
          narrativePagesIdsArray.forEach(onePage => {
            narrativePagesNew[onePage._id] = onePage
          })
          return narrativePagesNew[pageId]
        }

        const pagesArray = []

        oneNarrative.pages.forEach(pageId => {
          pagesArray.push(getPage(pageId))
        })
        oneNarrative.pages = pagesArray;
        // return (narratives)
      }, function done(err) {
        if (err) { console.error(err); return; }
      });
    }
    return narratives
  }

  const [ui, setUi] = useState({ ...ui_local });
  const [jyotish, setJyotish] = useState({ ...jyotish_ui });
  // const [ui, setUi] = useState(getLocal('lang_ui') ? getLocal('lang_ui') : null);
  // const [ui, setUi] = useState(null);
  // const [ui, setUi] = useState({});

  // const [types, setTypes] = useState({ ...types_local })
  // const [profiles, setProfiles] = useState({ ...profiles_local })
  const [types, setTypes] = useState(getLocal('data') && getLocal('data').types ? getLocal('data').types : {})
  const [profiles, setProfiles] = useState(getLocal('data') && getLocal('data').profiles ? getLocal('data').profiles : {})
  const [lines, setLines] = useState(getLocal('data') && getLocal('data').lines ? getLocal('data').lines : {})
  const [environments, setEnvironments] = useState(getLocal('data') && getLocal('data').environments ? getLocal('data').environments : {})
  const [centers, setCenters] = useState(getLocal('data') && getLocal('data').centers ? getLocal('data').centers : {})
  const [authorities, setAuthorities] = useState(getLocal('data') && getLocal('data').authorities ? getLocal('data').authorities : {})
  const [planets, setPlanets] = useState(getLocal('data') && getLocal('data').planets ? getLocal('data').planets : {})
  // const [gates, setGates] = useState({})
  const [gates, setGates] = useState(getLocal('data') && getLocal('data').gates ? getLocal('data').gates : {})
  const [channels, setChannels] = useState(getLocal('data') && getLocal('data').channels ? getLocal('data').channels : {})
  const [videos, setVideos] = useState(getLocal('data') && getLocal('data').videos ? processVideos(getLocal('data').videos) : [])
  // const [videos, setVideos] = useState([])
  const [crosses, setCrosses] = useState(getLocal('data') && getLocal('data').crosses ? processCrosses(getLocal('data').crosses) : {})
  const [variables, setVariables] = useState(getLocal('data') && getLocal('data').variables ? getLocal('data').variables : {})

  // const [narratives, setNarratives] = useState(
  //   getLocal('narratives')
  //     ? getLocal('narratives')
  //     : { 'default': defaultNarrative }
  // )



  const [narrativePages, setNarrativePages] = useState(
    getLocal('data')
      && getLocal('data').narrative_pages ? getLocal('data').narrative_pages
      : {}
  )

  const [narratives, setNarratives] = useState(
    (
      getLocal('data')
      && getLocal('data').narratives
      && getLocal('data').narrative_pages
    )
      ? processNarratives(getLocal('data').narratives, getLocal('data').narrative_pages)
      : {}
  )


  const [pentaNarrativePages, setPentaNarrativePages] = useState(penta_narrative_pages)
  const [pentaNarratives, setPentaNarratives] = useState(() =>
    buildPentaNarratives(penta_narratives, penta_narrative_pages)
  )

  const [pentaNarrativeCurrent, setPentaNarrativeCurrentInner] = useState(() => {
    const saved = getLocal('pentaNarrative');
    const hash = typeof window !== 'undefined'
      ? new URLSearchParams(window.location.hash.slice(1))
      : null;
    const hashN = hash?.get('n');
    if (hashN === 'compare' || hashN === 'composite') return hashN;
    if (hash?.has('compare')) return 'compare';
    if (hash?.has('composite')) return 'composite';
    return saved || 'composite';
  })

  const setPentaNarrativeCurrent = (narrative) => {
    setPentaNarrativeCurrentInner(narrative);
    setLocal('pentaNarrative', narrative)
  }


  const [narrativeCurrent, setNarrativeCurrentInner] = useState(() => {
    const saved = getLocal('narrative');
    const hashN = typeof window !== 'undefined'
      ? new URLSearchParams(window.location.hash.slice(1)).get('n')
      : null;
    // localStorage is the persisted choice; hash can override on a shared
    // link, but `public` is only the unlogged display default and must not
    // clobber a saved simple/pro selection.
    if (hashN && hashN !== 'public' && hashN !== 'uncertain') return hashN;
    if (saved && saved !== 'uncertain') return saved;
    return 'simple';
  })

  const setNarrativeCurrent = (narrative) => {
    if (narrative === 'uncertain') return;
    setNarrativeCurrentInner(narrative);
    setLocal('narrative', narrative)
  }



  useEffect(() => {
    if (ui && Object.keys(ui).length) {
      setLocal('lang_ui', ui)
    }
  }, [ui])




  // Penta narratives ship as bundled JSON — they are not on the Airtable cache.
  // Requesting them on first load (incognito / empty localStorage) 404s and
  // used to abort the whole Promise.all, so no narratives rendered at all.
  const dataKeys = [
    'changes',
    'profiles',
    'types',
    'planets',
    'lines',
    'gates',
    'channels',
    'environments',
    'authorities',
    'centers',
    'videos',
    'crosses',
    'variables',
    'celebs',
    'narratives',
    'narrative_pages'
  ]




  const processData = (data) => {
    const processedData = {};
    data.forEach(item => {
      if (item && item.table) {
        processedData[item.table] = Object.fromEntries(
          Object.entries(item).filter(([key, value]) => typeof value === 'object' && value !== null)
        );
        if (getLocal('data')) {
          const localData = getLocal('data') || {};
          localData[item.table] = processedData[item.table];
          setLocal('data', localData);
        }
      }
      if (item && !item.table) {
        processedData['changes'] = item;
      }
    });
    if (!getLocal('data')) {
      setLocal('data', processedData)
    }
    return processedData; // Return the named object
  };


  const fetchStaticData = async (dataKeys) => {
    try {
      const uniqueKeys = [...new Set(['changes', ...dataKeys])];
      const data = (await Promise.all(uniqueKeys.map(async (key) => {
        try {
          const response = await fetch(`${APP_AIRTABLE_CACHE}/${key}.json`);
          if (!response.ok) return null;
          return await response.json();
        } catch (error) {
          console.error(`Error fetching static data ${key}:`, error);
          return null;
        }
      }))).filter(Boolean);

      if (!data.length) return;

      const setTables = (processedData) => {
        if (processedData.changes) setLocal('changes', processedData.changes || []);
        if (processedData.types) setTypes(processedData.types || {});
        if (processedData.profiles) setProfiles(processedData.profiles || {});
        if (processedData.narrative_pages) setNarrativePages(processedData.narrative_pages || {});
        if (processedData.narratives) setNarratives(processNarratives(processedData.narratives, processedData.narrative_pages));
        if (processedData.penta_narrative_pages) setPentaNarrativePages(processedData.penta_narrative_pages);
        if (processedData.penta_narratives || processedData.penta_narrative_pages) {
          setPentaNarratives(buildPentaNarratives(
            processedData.penta_narratives || penta_narratives,
            processedData.penta_narrative_pages || penta_narrative_pages
          ));
        }
        // setUi(processedData.ui || {});
        // celebs moved to CelebsContext
        if (processedData.planets) setPlanets(processedData.planets || {});
        if (processedData.lines) setLines(processedData.lines || {});
        if (processedData.gates) setGates(processedData.gates || {});
        if (processedData.channels) setChannels(processedData.channels || {});
        if (processedData.environments) setEnvironments(processedData.environments || {});
        if (processedData.authorities) setAuthorities(processedData.authorities || {});
        if (processedData.centers) setCenters(processedData.centers || {});
        if (processedData.videos) setVideos(processVideos(processedData.videos) || {});
        if (processedData.crosses) setCrosses(processCrosses(processedData.crosses || {}));
        if (processedData.variables) setVariables(processedData.variables || {});
      }

      setTables(processData(data));

    } catch (error) {
      console.error('Error fetching static data:', error);
    }
  };




  const fetchChanges = async () => {
    try {
      const response = await fetch(`${APP_AIRTABLE_CACHE}/changes.json`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const changesServer = await response.json();
      return changesServer;
    } catch (error) {
      console.error('Error fetching changes:', error);
      return null; // Return null or handle the error as needed
    }
  };


  useEffect(() => {
    if (getLocal('data')) {
      const changesLocal = getLocal('changes') || {};

      // Fetch changes and handle the promise
      fetchChanges(changesLocal).then(changesServer => {
        const delta = Object.keys(changesServer).filter((tableId) => {
          const tableServerTimeStamp = changesServer[tableId];
          const tableLocalTimeStamp = changesLocal[tableId];
          return tableServerTimeStamp !== tableLocalTimeStamp;
        });

        // console.log('delta = ', delta);

        if (delta.length) {
          setChanges(changesServer);
          setLocal('changes', changesServer);
          fetchStaticData(delta);
        }

      }).catch(error => {
        console.error('Error fetching changes:', error);
      });
    } else {
      fetchStaticData(dataKeys);
    }
  }, []);





  const narrativesAll = useMemo(
    () => ({ ...narratives, ...UNCERTAIN_NARRATIVES }),
    [narratives]
  );

  const getNarrative = (id) => {

    if (narrativesAll[id]) { return narrativesAll[id] }
    else { return {} }
  }

  const getPentaNarrative = (id) => pentaNarratives[id] || {};






  useEffect(() => {
    setLocal('language', language)
  }, [ui])

  useEffect(() => {
    // console.log('narratives12312312312312313123213231232 = ', narratives);
  }, [narratives])







  // celebs moved to CelebsContext


  // celebsData moved to CelebsContext


  // celebsData moved to CelebsContext


  // parseCelebs moved to CelebsContext




  const $ui = (str, field, quantity = 1) => {
    if (ui && Object.keys(ui).length) {

      const lang = quantity > 1 && ui[str][`${language}+`] ? `${language}+` : language;
      if (!field) { return ui[str] ? ui[str][lang] : str }
      else { return ui[str][`${field}-${lang}`] ? ui[str][`${field}-${lang}`] : str }
    } else {
      return str
    }
  };

  const $ = (str, obj) => obj[`${str}-${language}`];



  const $type = (id, str) => types[id] ? types[id][`${str}-${language}`] ? types[id][`${str}-${language}`] : types[id][`${str}`] : id;
  const $profile = (id, str) => {
    let a = profiles[id] ? profiles[id][`${str}-${language}`] ? profiles[id][`${str}-${language}`] : profiles[id][`${str}`] : id
    return a
  }
  // const $line = (id, str) => lines[id] ? lines[id][`${str}-${language}`] ? lines[id][`${str}-${language}`] : lines[id][`${str}`] : <span className='x_txt_loading'>{id}</span>;
  const $line = (id, str) => lines[id] ? lines[id][`${str}-${language}`] ? lines[id][`${str}-${language}`] : lines[id][`${str}`] : id;
  const $vars = (id, str = 'title') => variables[id] ? variables[id][`${str}-${language}`] ? variables[id][`${str}-${language}`] : variables[id][`${str}`] : str !== 'title' ? '' : id;
  const $envs = (id, str) => environments[id] ? environments[id][`${str}-${language}`] ? environments[id][`${str}-${language}`] : environments[id][str] : str !== 'title' ? '' : id;
  const $center = (id, str) => centers[id] ? centers[id][`${str}-${language}`] ? centers[id][`${str}-${language}`] : centers[id][str] : str !== 'title' ? '' : id;
  const $auths = (id, str) => authorities[id] ? authorities[id][`${str}-${language}`] ? authorities[id][`${str}-${language}`] : authorities[id][str] : str !== 'title' ? '' : id;
  const $planet = (id, str) => planets[id] ? planets[id][`${str}-${language}`] ? planets[id][`${str}-${language}`] : planets[id][str] : str !== 'title' ? '' : id;
  const $channel = (id, str) => channels[id] ? channels[id][`${str}-${language}`] ? channels[id][`${str}-${language}`] : channels[id][str] : str !== 'title' ? '' : id;
  const $gate = (id, str) => gates[id] ? gates[id][`${str}-${language}`] ? gates[id][`${str}-${language}`] : gates[id][str] : str === 'title' ? '' : id;
  const $narr = (id, str) => {
    return narrativesAll[id] ? narrativesAll[id][`${str}-${language}`] ? narrativesAll[id][`${str}-${language}`] : narrativesAll[id][str] : id
  };

  const $pentaNarr = (id, str) => {
    const narrative = pentaNarratives[id];
    return narrative
      ? (narrative[`${str}-${language}`] || narrative[str] || id)
      : id;
  };

  const $jyotish = (id, str) => {
    // console.log('id = ', id);
    // console.log('str = ', str);
    return (jyotish[id] ? jyotish[id][`${str}-${language}`] ? jyotish[id][`${str}-${language}`] : jyotish[id][str] : id);
    // return (jyotish[id] ? jyotish[id][`${str}-${language}`] ? jyotish[id][`${str}-${language}`] : jyotish[id][str] : '');
  };

  const $cross = (id, str) => {
    return crosses[id] ? crosses[id][`${str}-${language}`] ? crosses[id][`${str}-${language}`] : crosses[id][str] : id
  };

  // $celebType moved to CelebsContext

  const defaultTitles = {
    en: {
      short: ''
      // short: 'Unnamed'
    },
    ru: {
      short: ''
      // short: 'Безымянный'
    }
  }

  const getDefaultTitle = (design, show = 'unnamed type') => {
    let ret = 'Unnamed'
    let typ = design ? design['type'] : ''
    let prof = design ? design['profile'] : []
    // if (show = 'type' && typ) ret = `${defaultTitles[language]['short']} ${drawType(typ)}`
    if (show === 'unnamed type' && typ) ret = `${defaultTitles[language]['short']} ${drawType(typ, 'short')}${drawProfile(prof)}`
    if (show === 'type' && typ) ret = `${drawType(typ, 'short')} ${drawProfile(prof)}`
    return ret;
  }



  const getVideoList = (rel, relValue, locale = language) => {

    // console.log('videos = ', videos);
    if (!videos.length) return []

    const varLabel = relValue.split('_')[0];
    const relLabelVideo = `label_${varLabel}`

    const getLabelVideo = videos
      .filter(one => {
        return one.locale.includes(locale)
      })
      .map(one => ({
        ...one,
        comment: one[`comment-${language}`]
      }))
      .filter(one => {
        return one[`rel-${rel}`] ? one[`rel-${rel}`]
          .includes(relLabelVideo) : false
      });

    // console.log('videos = ', videos);
    const videosLocale = videos
        .filter(one => {
          return one.locale.includes(locale)
        })
        .map(one => ({
          ...one,
          comment: one[`comment-${language}`]
        }))
        .filter(one => one[`rel-${rel}`] ? one[`rel-${rel}`].includes(relValue) : false)
    // console.log('videosLocale = ', videosLocale);
    return [...getLabelVideo, ...videosLocale]
  }

  const getVideoById = (youtubeId) => {
    let vid = videos.filter(one => one.youtubeId === youtubeId)[0];
    if (vid) {
      vid['comment'] = vid[`comment-${language}`];
    } else {
      vid = {}
    }
    return vid;
  }

  // getCelebCategory moved to CelebsContext

  const languages = ['en', 'ru']

  const [languageReady, setLanguageReady] = useState()

  useEffect(() => {
    if (
      Object.keys(ui).length &&
      Object.keys(types).length &&
      Object.keys(profiles).length &&
      Object.keys(lines).length &&
      Object.keys(gates).length &&
      Object.keys(variables).length &&
      Object.keys(environments).length &&
      Object.keys(authorities).length &&
      Object.keys(channels).length &&
      Object.keys(planets).length &&
      Object.keys(crosses).length
      // && videos.length
    ) {
      setLanguageReady(true)
    }
  }, [
    ui,
    types,
    profiles,
    lines,
    gates,
    variables,
    environments,
    authorities,
    channels,
    planets,
    crosses,
    videos
  ])



  

  return (
    <LangContext.Provider
      value={{
        languageReady,
        languages,
        language,
        amPm,
        narratives: narrativesAll,
        narrativeCurrent,
        pentaNarratives,
        pentaNarrativeCurrent,
        videos,
        lang: {
          ui,
          types,
          profiles,
          lines,
          gates,
          variables,
          environments,
          authorities,
          channels,
          planets,
          jyotish
        },
        setLanguage,
        $ui,
        $,
        $type,
        $profile,
        $line,
        $vars,
        $envs,
        $narr,
        $pentaNarr,
        $auths,
        $planet,
        $channel,
        $center,
        $gate,
        $cross,
        $jyotish,
        setNarrativeCurrent,
        setPentaNarrativeCurrent,
        getDefaultTitle,
        getNarrative,
        getPentaNarrative,
        getVideoList,
        getVideoById
      }}
    >
      {
        narrativesAll
        && children}
    </LangContext.Provider>
  )

}

const LangConsumer = LangContext.Consumer;

export { LangConsumer, LangContext, LangProvider };
